import React, { useRef, useState, useEffect } from "react";
import { toast } from "react-toastify";
import GeneralInformation from "./GeneralInformation";
import InfrastructurePhysicalEnvironment from "./InfrastructureEnvironment";
import EssentialServices from "./EssentialServices";
import AdditionalNotes from "./AdditionalNotes";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { fetchData } from "../../utils/functions";

const HealthFacilityAssessment = () => {
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("General Information");
  const scrollRef = useRef(null);
  const [isLeftClicked, setIsLeftClicked] = useState(false);
  const [isRightClicked, setIsRightClicked] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [loader, setLoader] = useState(false);
  const [schoolData, setSchoolData] = useState(null);
  const navigate = useNavigate();

  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permissions = loggedInUser?.user_permissions || [];

  //    const tabs = [
  //   "General Information",
  //   "Infrastructure & Physical Environment",
  //   "Essential Services Availability",
  // ];

  const allTabs = [
    {
      name: "General Information",
      permission: "health-facility-assessment-update",
    },
    {
      name: "Infrastructure & Physical Environment",
      permission: "infrastructure-physical-environement-update",
    },
    {
      name: "Essential Services Availability",
      permission: "essential-services-availability-update",
    },
  ];

  //Filter allowed tabs
  const allowedTabs = allTabs.filter((tab) =>
    permissions.includes(tab.permission)
  );
  //Set default active tab
  useEffect(() => {
    if (allowedTabs.length > 0) {
      setActiveTab(allowedTabs[0].name);
    }
  }, [permissions]);

  const scrollTabs = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });

      if (direction === "left") {
        setIsLeftClicked(true);
        setTimeout(() => setIsLeftClicked(false), 200);
      } else {
        setIsRightClicked(true);
        setTimeout(() => setIsRightClicked(false), 200);
      }
    }
  };

  const fetchHealthFacilityAssessment = async () => {
    try {
      setLoader(true);
      setIsFetching(true);

      const response = await fetchData(
        `health-fetchById/${id}`,
        "GET",
        null,
        {},
        {},
        navigate
      );

      if (response?.data) {
        setSchoolData(response.data);
      }
    } catch (error) {
      console.error("Error fetching school data:", error);
      toast.error("Failed to load school data.");
    } finally {
      setLoader(false);
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchHealthFacilityAssessment();
  }, [id]);

  return (
    <div>
      <h1 className="text-[1.475rem] text-black font-bold">
        Health Facility Assessment
      </h1>

      <div className="mt-6">
        {/* Tabs Navigation */}
        <div className="flex items-center rounded-t-lg bg-[#fdf5ec] relative">
          {/* Left Scroll Button */}
          <button
            onClick={() => scrollTabs("left")}
            className={`text-xl px-4 py-2 font-bold rounded-lg transition-colors ${
              isLeftClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            «
          </button>

          {/* Scrollable Tabs */}
          <div
            ref={scrollRef}
            className="flex gap-4 overflow-hidden scrollbar-hide"
          >
            {allowedTabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => setActiveTab(tab.name)}
                className={`px-10 py-2 font-semibold whitespace-nowrap ${
                  activeTab === tab.name
                    ? "bg-[#caa316] text-white"
                    : "text-black"
                }`}
                style={{
                  borderTopLeftRadius: "13px",
                  borderTopRightRadius: "30px",
                }}
              >
                {tab.name}
              </button>
            ))}
          </div>

          {/* Right Scroll Button */}
          <button
            onClick={() => scrollTabs("right")}
            className={`ml-auto text-xl px-4 py-2 rounded-lg font-bold transition-colors ${
              isRightClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            »
          </button>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-b-lg shadow-md p-6">
          {activeTab === "General Information" && (
            <GeneralInformation healthFacility={schoolData?.healthFacility} />
          )}
          {activeTab === "Infrastructure & Physical Environment" && (
            <InfrastructurePhysicalEnvironment
              healthInfrastructure={schoolData?.healthInfrastructure}
            />
          )}
          {activeTab === "Essential Services Availability" && (
            <EssentialServices 
              healthServices={schoolData?.healthServices}
              healthStatus={schoolData?.healthFacility?.health_status}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HealthFacilityAssessment;